<template>
	<div class="page-style-a">
		<div class="container">
			<div class="page-intro">
				<h2>Requirements List</h2>
				<ul class="bread-crumb">
					<li class="has-separator">
						<i class="ion ion-md-home"></i>
						<router-link :to="{name : 'Home'}">Home</router-link>
					</li>
					<li class="is-marked">
						<a href="account.html">requirements list</a>
					</li>
				</ul>
			</div>
		</div>
	</div>
	<div class="row mt-3 m-0">
		<div style="width: 100%">
			<Spinner v-if="loading.data" style="height: 100px" />
		</div>
		<!-- Product Not Found -->
		<div
			class="product-not-found"
			v-if="requirements.length == 0 && !loading.data"
			style="width: 100%"
		>
			<div class="not-found">
				<h2>SORRY!</h2>
				<h6>There is not any products in this category.</h6>
			</div>
		</div>
		<div class="col-lg-9 mx-auto">
			<!-- List group-->
			<ul class="list-group shadow">
				<!-- list group item-->
				<li
					class="list-group-item mt-2"
					v-for="(requirement, index) in requirements"
					:key="index"
				>
					<!-- Custom content-->
					<div class="media align-items-lg-center flex-column flex-lg-row p-3">
						<div class="media-body order-2 order-lg-1">
							<h5 class="mt-0 font-weight-bold mb-2">
								{{ formatDate(requirement.created_at) }}
							</h5>
							<div v-if="requirement.requirement.length > 100">
								<p class="font-italic text-muted mb-0 small" v-if="viewMorePostIndex == index">
									{{ requirement.requirement }}
									<b class="link" @click="readLess()">Read Less</b>
								</p>
								<p class="font-italic text-muted mb-0 small" v-if="viewMorePostIndex != index">
									{{ requirement.requirement.slice(0, 100) + "...." }}.
									<b class="link" @click="readMore(index)">Read More</b>
								</p>
							</div>
							<p class="font-italic text-muted mb-0 small" v-else>
								{{ requirement.requirement }}
							</p>
							<div class="d-flex align-items-center justify-content-between mt-1">
								<h6 class="font-weight-bold my-2">
									Budget : {{ formatCurrency(requirement.budget) }}
								</h6>
							</div>
							<div class="d-flex align-items-center justify-content-between">
								<h6 class="font-weight-bold">Address : {{ requirement.city }}</h6>
							</div>
						</div>
						<img
							alt="Generic placeholder image"
							width="200"
							class="ml-lg-5 order-1 order-lg-2 rounded-circle"
							v-lazy="{
								src: publicPath + 'assets/avatar/' + getRandomAvatar(requirement.user.id),
								loading: publicPath + 'assets/images/spinner.gif',
								error: publicPath + 'assets/images/not_found.png',
							}"
						/>
					</div>
					<!-- End -->
				</li>
			</ul>
			<Spinner v-if="loading.pagination" style="height: 100px" />
			<div v-if="!loading.data && !loading.pagination && requirements.length != 0">
				<div
					v-if="current_page == last_page"
					class="redirect-link-wrapper text-center u-s-p-t-25 u-s-p-80"
					style="width: 100%"
				>
					<a class="redirect-link">End of list</a>
				</div>
				<div
					v-if="current_page != last_page"
					class="redirect-link-wrapper text-center u-s-p-t-25 u-s-p-80"
					style="width: 100%"
					@click="viewMore()"
				>
					<a class="redirect-link">View more</a>
				</div>
			</div>
			<!-- End -->
		</div>
	</div>
	<Footer />
</template>

<script>
	import axios from "axios";
	import Footer from "../components/Bottom/Footer.vue";
	import {formatCurrency} from "../utils/common_functions.js";
	import moment from "moment";
	import Spinner from "../components/Loaders/Spinner.vue";
	import {publicPath} from "../../vue.config";
	export default {
		computed: {
			getRandomeAvatar() {
				return Math.floor(Math.random() * 10) + 1;
			},
		},
		components: {
			Footer,
			Spinner,
		},
		data() {
			return {
				requirements: [],
				viewMorePostIndex: null,
				total: 0,
				last_page: 0,
				current_page: 0,
				loading: {data: false, pagination: false},
				publicPath: publicPath,
				avatar_png: [
					"av1.png",
					"av2.png",
					"av3.png",
					"av4.png",
					"av5.png",
					"av6.png",
					"av7.png",
					"av8.png",
					"av9.png",
					"av10.png",
				],
			};
		},
		methods: {
			formatCurrency,
			formatDate(date) {
				return moment(date).format("Do MMMM YYYY, h:mm:ss a");
			},
			async getRequirements(loading_type) {
				this.setLoading(loading_type, true);
				try {
					let url = `${process.env.VUE_APP_API_URL}/api/get-automation-requirement`;
					url = `${url}?page=${this.current_page}`;
					const headers = {
						Authorization: `Bearer ${localStorage.getItem("token")}`,
					};
					const {data} = await axios.post(url, {headers});
					this.setLoading(loading_type, false);
					this.requirements.push(...data.data);
					this.total = data.total;
					this.last_page = data.last_page;
					this.current_page = data.current_page;
				} catch (error) {
					console.log(error);
					this.setLoading(loading_type, false);
				}
			},
			readMore(index) {
				this.viewMorePostIndex = index;
			},
			readLess() {
				this.viewMorePostIndex = null;
			},
			viewMore() {
				this.current_page++;
				this.getRequirements("pagination");
			},
			setLoading(value, status) {
				this.loading[value] = status;
			},
			getRandomAvatar(user_id) {
				return this.avatar_png[user_id % 10];
			},
		},
		mounted() {
			this.getRequirements("data");
		},
	};
</script>

<style scoped>
	.link {
		cursor: pointer;
	}
</style>
